<template>
  <div class="pointList">
    <nyhead
      :marks="list.value"
      :name="list.name"
      @handClickFs="handClickFs"
    ></nyhead>
    <div class="intes-bt-box" v-show="list.length !== 0">
      <zklist :list="list.son"></zklist>
      <div class="tswz">
        该分析为功能评估，结果不作为临床诊断标准，如需诊断是否患有疾病，请到专业医疗机构进行诊断检查。
      </div>
    </div>

    <div v-show="list.length == 0" style="text-align: center">暂无数据</div>
  </div>
</template>
<script>

import zklist from "./zklist.vue"
import nyhead from "./nyhead.vue"
export default {
  props: ['list', 'marks',],
  components: {
    zklist, nyhead
  },
  data () {
    return {
      activeNames: [],

    }
  },
  watch: {
    list: {
      handler (newValue, oldValue) {
        console.log(newValue)
        this.list = newValue;
      },
      deep: true,
      immediate: true
    },
  },
  methods: {

    handClickFs () {
      this.$emit('fatherMethod');
    }
  }
}
</script>
<style lang="scss" scoped>
.mytab {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.intes-bt {
  height: 250px;
  .intes-bt-img {
    position: absolute;
    width: 280px;
    height: 291px;
    left: 50%;
    top: 0;
    margin-left: -140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .intes-bt-test {
    position: absolute;
    width: 280px;
    height: 291px;
    left: 50%;
    top: 0;
    margin-left: -135px;
    padding-top: 60px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    b {
      font-size: 72px;
      font-weight: bolder;
    }
    p {
      font-size: 20px;
      margin: 0;
      color: #999;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: -5px;
    }
  }
  .intes-bt-fs {
    position: absolute;
    right: 27px;
    top: 10px;
    text-decoration: underline;
    font-size: 22px;
    color: #fff;
  }
}
.intes-bt-box {
  padding: 0 30px;
  .intes-bt-box-tit {
    font-size: 24px;
    color: #fff;
    margin-bottom: 16px;
  }
  .mt20 {
    margin-top: 30px;
    font-size: 24px;
    color: #666;
  }
  .tswz {
    font-size: 20px;
    color: #666;
    margin: 30px 0;
    line-height: 30px;
  }
  .zxtjt {
    background: #fff;
    height: 450px;
  }
  .zxtjtr {
    font-size: 20px;
    margin: 30px 0 0 30px;
    color: #8c8c8c;
  }

  .pointImgcomment1 {
    display: flex;
    img {
      width: 65px;
      height: 65px;
      vertical-align: middle;
      margin-right: 20px;
    }
    .span1 {
      font-size: 26px;
      vertical-align: middle;
      display: inline-block;
    }
    b {
      font-weight: 400;
      font-size: 26px;
    }
    div {
      flex: 1;
    }
    .span2 {
      font-size: 22px;
      display: inline-block;
      margin-top: 10px;
      i {
        color: #d45353;
      }
    }
  }
}
</style>